"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECGSnapshot_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ECGSnapshot_Factory = /** @class */ (function () {
    function ECGSnapshot_Factory() {
    }
    ECGSnapshot_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            FileId: model.FileId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SurgeryVitalsId: model.SurgeryVitalsId,
        };
        return result;
    };
    ECGSnapshot_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            FileId: model.FileId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SurgeryVitalsId: model.SurgeryVitalsId,
        };
        return result;
    };
    return ECGSnapshot_Factory;
}());
exports.ECGSnapshot_Factory = ECGSnapshot_Factory;
